import React from 'react'

function Loader() {
    return (
        <div>
          <h1>loading</h1>  
        </div>
    )
}
export default Loader;
